/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-download': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M4 16v4h16v-4h2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4h2zm9-14v10.586l3.293-3.293 1.414 1.414L12 16.414l-5.707-5.707 1.414-1.414L11 12.586V2h2z" _fill="#7E8994" fill-rule="evenodd"/>'
  }
})
